import { createIdentifier } from '@wendellhu/redi';
import type { CaseMetaDto } from '../dto/solution.dto';

export interface ISolutionApplicationService {
  getCaseMeta(solutionId: number): Promise<CaseMetaDto>;
  setImagingSelection(solutionId: number, imagingId: number | null, activeSeriesId: string): Promise<void>;
  updateStatus(params: {
    solutionId: number;
    caseId: number;
    versionId: number;
    status: string;
  }): Promise<void>;
}

export const ISolutionApplicationService = createIdentifier<ISolutionApplicationService>('backend.solution.application');
